export const useStyles = ({ colors, breakpoints }) => ({
  whiteBox: {
    backgroundColor: colors.warningBox,
    minHeight: ({ height }) => height || "304px",
    height: "auto",
    margin: "0px 0 20px 20px",
    width: ({ width = "640" }) => `${width}px`,
  },
});
